import React from 'react';
import { Brands } from '../../models/brands';
import { BrandStyling } from '../../theme/brandStyling';

type TipButtonsProps = {
    onClickHandler: (value: number) => void;
    selectedTipValue?: number;
    currencySymbol: '£' | '€';
    brandId: Brands;
    tipButtonValues: number[];
};

const TipButtons: React.FC<TipButtonsProps> = ({
    onClickHandler,
    selectedTipValue,
    brandId,
    currencySymbol,
    tipButtonValues,
}) => {
    const styling = BrandStyling.byBrand(brandId);
    return (
        <div
            className={`flex w-full justify-center mt-10`}
        >
            {tipButtonValues.map((item, index) => {
                const isSelected =
                    selectedTipValue &&
                    Math.round(selectedTipValue * 100) / 100 === item;
                return (
                    <button
                        key={index}
                        onClick={() => onClickHandler(item)}
                        className={`w-1/4 h-16 mt-2 mx-1.5 rounded-lg ${isSelected
                            ? styling.tipButtonFocus
                            : styling.tipButton}`}
                    >
                        <div
                            className={` w-full h-full flex items-center justify-center text-[26px] font-medium`}
                        >
                            {currencySymbol + item}
                        </div>
                    </button>
                );
            })}
        </div>
    );
};

export default TipButtons;
